import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginModel, LoginResultModel } from '../definition';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { IdentityStore } from '../identity-store';
import { identityConstants } from '../identity-constants';
import { MmHttpClient } from '../../http';
import { PermissionModel } from '../definition/permission.model';
// import { SubjectService } from "../../../shared/services";
import { isTokenExpired } from '../is-token-expired';

@Injectable({ providedIn: 'root' })
export class MmIdentityService {
  constructor(
    private httpClient: MmHttpClient,
    private activedRoute: ActivatedRoute,
    private router: Router,
    // private subjectService: SubjectService,
    private store: IdentityStore) {

  }

  login(model: LoginModel, autoRedirect: boolean = true) {
    var redirectUrl = this.activedRoute.snapshot.queryParams["redirectUrl"];
    return this.httpClient.post<LoginResultModel>(`${identityConstants.identityApiRoute}/login`, model).pipe(
      tap(result => {
        if (result.success) {

          this.store.token = result.token;
          this.store.permissions = result.permissions;
          this.store.refreshToken = result.refreshToken;
          if (autoRedirect) {
            if (redirectUrl) {
              this.router.navigateByUrl(redirectUrl);
            }
            else {
              this.router.navigate(['.']);
            }
          }
        }

      }),
    )
  }

  getPermissionTree() {
    return this.httpClient.get<PermissionModel[]>(`api/menu/permission/tree`)
  }



  logout() {
    this.store.clear();
    // localStorage.removeItem("token");
    // localStorage.removeItem("permissions");
    this.router.navigate(["login"]).then(() => {
      // this.subjectService.setIsAlarmShielding(true);
    });

  }

  get isAuthenticated() {

    var token = this.store.token;
    if (token == undefined) return false;
    var refreshToken = this.store.refreshToken;
    if (isTokenExpired(token) && isTokenExpired(refreshToken)) {
      return false;
    }
    return true;

    // return token != undefined;
  }

  getUserDisplayNames(ids: string[]) {
    return this.httpClient.get<{ [key: string]: string }[]>(`${identityConstants.identityApiRoute}/userDisplayNames`, {
      params: {
        id: ids
      }
    })

  }

  changePassword(model: { password: string, newPassword: string }) {
    return this.httpClient.post(`${identityConstants.identityApiRoute}/changePassword`, model, {})

  }

  hasPermission(permission: string) {
    if (this.store.permissions == undefined) return false;
    return this.store.permissions.findIndex(p => p.startsWith(permission)) >= 0;
  }




}
